import React, { useEffect, useState } from "react";
import Header from "../HeaderComponent/Header";
import Claimdetail from "./Claimdetail";
import Menu from "../MenuComponent/Menu";
import FooterComponent from "../FooterComponent/FooterComponent";
import Dropdown from "../../Helper/Dropdown";
import "./taload.css";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux/es/exports";
import TextField from "../../Helper/TextField";
import { GET_CLAIM } from "../../redux/Claimdata/types";

import { v4 as uuid } from "uuid";

import { useSelector } from "react-redux/es/exports";
import { useNavigate } from "react-router-dom";
import axiosinstances from "../../Helper/useAxios";

const Taload = () => {
  const [allbankname, setAllbankname] = useState([])
  const [axiosInstance] = axiosinstances()
  const token = JSON.parse(sessionStorage.getItem("token"));
  const navigate = useNavigate();
const payeeName =  process.env.REACT_APP_PAYEE_NAME
const payeeUpi =  process.env.REACT_APP_PAYEE_UPI
const acoountNumber = process.env.REACT_APP_PAYEE_ACCOUNT
const bankNames= process.env.REACT_APP_BANK
const bankIfsc = process.env.REACT_APP_IFSC
const bankType = process.env.REACT_APP_ACTYPE
  const id = useSelector((state) => state.getprofilereducer?.getprofile?.id);
  const unique_id = uuid();
  const dispatch = useDispatch();

  const dashBoard = () => {
    navigate("/bill-payment");
  };
  const toTareq = () => {
    navigate("/ta-load-request");
  };
  
  const getBankHistory = () =>{
    axiosInstance.get(`/api/v1/catalog/bank/all/summary`,   {
      headers: { Authorization: `Bearer ${token}`,
      "client-id": id, role: "ROLE_RETAILER_FINXPAY"}
      } )
      .then((res)=>{
        //console.log('res-->', res)
        setAllbankname(res?.data)
      })
      .catch((err)=>console.log(err))
  } 
  useEffect(()=>{
    if(id !== undefined){
      getBankHistory()
    }
   
  },[id])
  //toTareq
  const numberregex = /^[0-9]*$/
  
  const validate = Yup.object({
    amount: Yup.string()
    .matches(numberregex, 'only number is allowed')
    .required("Enter Valid number"),
    utr: Yup.string().required("Transaction Is Required"),
    bank: Yup.string().required("Bank Is Required"),
    txnDate: Yup.string().required("Transaction Date Is Required"),
    txnMode: Yup.string().required("Transaction Mode Is Required"),
    Comment: Yup.string().required("Comment Is Required"),
  });

  const Transactionmode = [ "UPI", "NEFT/RTGS"];
  const Bankname = ["Select", "State Bank Of India", "icici", "HDFC", "Axis"];
  const new_id = id
  return (
    <React.Fragment>
      <div className="mid">
        <div className="container-fluid">
          <div className="head">
            <h3>Claim TA Load</h3>
            <button className="btn" type="button" onClick={dashBoard}>
              Back
            </button>
            <button className="btn" type="button" onClick={toTareq}>
              Ta Load Request List
            </button>
          </div>

          <Formik
            initialValues={{
              entityId: new_id,
              amount: "",
              utr: "",
              refId: `${unique_id}`,
              bank: allbankname !== undefined &&  allbankname.length > 0 ? allbankname[0].name: '',
              txnDate: "",
              txnMode: Transactionmode[0],
              Comment: "",
            }}
            validationSchema={validate}
            onSubmit={(values) => {
             // //console.log('submit call', values)
              dispatch({ type: GET_CLAIM, payload: { values, navigate, id } });
            }}
          >
            {(formik, setFieldValue, props) => (
              <>
                <Form>
                  <div className="addform">
                    <div className="row">
                      <div className="col-12 col-lg-8">
                        <div className="row">
                          <div className="col-12 col-md-6">
                            <div className="formrow">
                              <div className="form-floating">
                                <TextField
                                  label="Enter your amount"
                                  placeholder="Enter your amount"
                                  name="amount"
                                  type="text"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-md-6">
                            <div className="formrow">
                              <div className="form-floating mb-2">
                                <select
                                  name="bank"
                                  id="bank"
                                  className={`form-select ${
                                    formik.touched &&
                                    formik.error &&
                                    "is-invalid"
                                  }`}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.bank}
                                >
                                  <option >select</option>
                                  {allbankname !== undefined && allbankname.length > 0 && allbankname.map((bank, index) => (
                                    <option value={bank.name} key={index}>
                                      {bank.name}
                                    </option>
                                  ))}
                                </select>

                                <label for="floatingSelect">Bankname</label>
                                {formik.touched.bank && formik.errors.bank && (
                                  <span className="text-red-400">
                                    {formik.errors.bank}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6">
                            <div className="formrow">
                              <div className="form-floating ">
                                <TextField
                                  label="Transaction ID"
                                  placeholder="Transaction ID"
                                  name="utr"
                                  type="text"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-md-6">
                            <div className="formrow">
                              <div className="form-floating ">
                                <TextField
                                  label="Transaction Date"
                                  placeholder="transaction Date"
                                  name="txnDate"
                                  type="date"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-md-6">
                            <div className="formrow">
                              <div className="form-floating ">
                                <div className="form-floating mb-2">
                                  <select
                                    name="txnMode"
                                    id="txnMode"
                                    className={`form-select ${
                                      formik.touched &&
                                      formik.error &&
                                      "is-invalid"
                                    }`}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.txnMode}
                                  >
                                    {Transactionmode.map((txnMode, index) => (
                                      <option value={txnMode} key={index}>
                                        {txnMode}
                                      </option>
                                    ))}
                                  </select>

                                  <label for="floatingSelect">
                                    Transaction Mode
                                  </label>
                                  {formik.touched.txnMode &&
                                    formik.errors.txnMode && (
                                      <span className="text-red-400">
                                        {formik.errors.txnMode}
                                      </span>
                                    )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-12 col-md-6">
                            <div className="formrow">
                              <div className="form-floating">
                                <TextField
                                  label="Comment"
                                  placeholder="Comment"
                                  name="Comment"
                                  type="text"
                                />
                              </div>
                            </div>
                          </div>

                          <div className="col-12">
                            <button className="btn btn-primary" type="submit" disabled={!formik.isValid} >
                              Submit
                            </button>
                          </div>

                          <div className="col-12">
                            <div className="notxt">
                              <p>
                                If the transaction was a success, your Corporate
                                account would be credited instantly once (Only
                                during Banking hours).
                              </p>
                              <p className="text-danger">
                                Note - This won’t be applicable if your official
                                bank account is Yes Bank.
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12 col-lg-4">
                        <div className="bankcard">
                          <div className="btbtnsfr">
                            <h4>Bank-to-Bank Transfer Details</h4>

                            <p>
                              Now you can load money in your corporate virtual
                              account through NEFT/RTGS as per process shown
                              below.
                            </p>

                            <p>
                              Account Details for adding Payee as mentioned as
                              below:
                            </p>

                            <div className="table-responsive">
                              <table className="table table-bordered table-striped">
                                <tbody>
                                  <tr>
                                    <td>Payee Name:</td>
                                    <td>{payeeName}</td>
                                  </tr>
                                  <tr>
                                    <td>UPI ID:</td>
                                    <td>{payeeUpi}</td>
                                  </tr>
                                  <tr>
                                    <td>Account Number:</td>
                                    <td>{acoountNumber}</td>
                                  </tr>
                                  <tr>
                                    <td>Bank Name:</td>
                                    <td>{bankNames}</td>
                                  </tr>
                                  <tr>
                                    <td>Bank IFSC Code:</td>
                                    <td>{bankIfsc}</td>
                                  </tr>
                                  <tr>
                                    <td>Account Type:</td>
                                    <td>{bankType}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="bankcard">
                          <div className="banksteps">
                            <ul>
                              <li>
                                <i className="step1"></i>
                                <h6>
                                  Login to bank account and <br />
                                  go to "Fund Transfer"
                                </h6>
                                <span className="steparrow"></span>
                              </li>
                              <li>
                                <i className="step2"></i>
                                <h6>
                                  Click on Add Beneficiary or <br />
                                  Register a new Payee
                                </h6>
                                <span className="steparrow"></span>
                              </li>
                              <li>
                                <i className="step3"></i>
                                <h6>
                                  Select Other* Bank NEFT/RTGS <br />
                                  transfer and enter the amount
                                </h6>
                                <span className="steparrow"></span>
                              </li>
                              <li>
                                <i className="step4"></i>
                                <h6>
                                  Click on "Confirm" button to <br />
                                  complete the transaction
                                </h6>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Form>
              </>
            )}
          </Formik>
        </div>
      </div>
    </React.Fragment>
  );
};

export default Taload;
